import { template as template_ed7ded7e54a549eb97ade7c2d740dff0 } from "@ember/template-compiler";
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { service } from '@ember/service';
import { isPresent } from '@ember/utils';
import { action } from '@ember/object';
import { t } from 'ember-intl';
import Portal from 'ember-stargate/components/portal';
import SearchTag from 'eflex/components/filters/search-tag';
import FilterWrapper from 'eflex/components/filters/filter-wrapper';
export default class BiPanelShifts extends Component {
    @service
    scheduleRepo;
    @service
    intl;
    @tracked
    isDisplayed = false;
    constructor(){
        super(...arguments);
        this.isDisplayed = this.args.shiftNames?.length > 0;
        this.args.initParam('shiftNames', this.args.shiftNames);
    }
    @action
    onChange(shifts) {
        this.args.updateParam('shiftNames', shifts);
    }
    get shifts() {
        const set = new Set();
        this.scheduleRepo.schedules.forEach((schedule)=>{
            if (this.checkShiftAvailability(schedule)) {
                set.add(schedule.text);
            }
        });
        return [
            ...set
        ];
    }
    get selectedShifts() {
        return this.args.getParam('shiftNames');
    }
    get selectedShiftsBadgeText() {
        return this.args.createSearchBadgeText('shiftNames', 'shift', 'criteria.selectedShifts');
    }
    checkShiftAvailability(shift) {
        if (new Date(shift.startDate) > new Date(this.args.endDate) || new Date(shift.endDate) < new Date(this.args.startDate)) {
            return false;
        }
        shift.stations?.forEach((station)=>{
            if (!this.args.stationIds?.includes(station)) {
                return false;
            }
        });
        return true;
    }
    onDisplayedChanged = ()=>{
        this.isDisplayed = !this.isDisplayed;
    };
    static{
        template_ed7ded7e54a549eb97ade7c2d740dff0(`
    <Portal @target="filter-fields">
      <FilterWrapper
        class="eflex-shifts-criteria"
        @class="align-items-end"
        @form={{@form}}
        @label="shifts"
        @isDisplayed={{this.isDisplayed}}
        @onChecked={{this.onDisplayedChanged}}
        @hasValue={{isPresent this.selectedShifts}}
        ...attributes
      >
        <div class="input-group">
          <div class="col">
            <div class="row">
              <div class="col">
                <@form.element
                  class="shift-select"
                  @controlType="power-select-multiple"
                  @value={{this.selectedShifts}}
                  @options={{this.shifts}}
                  @onChange={{this.onChange}}
                as |el|>
                  <el.control
                    class="sm"
                    @searchEnabled={{true}}
                    @searchField="text"
                    @placeholder={{t "allShifts"}}
                  />
                </@form.element>
              </div>
            </div>
          </div>
        </div>
      </FilterWrapper>
    </Portal>

    <Portal @target="search-badge-tags">
      <SearchTag
        @isDisplayed={{@shiftNames}}
        @text={{this.selectedShiftsBadgeText}}
      />
    </Portal>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
